import { ContentActionGq } from './ContentActionGq';

export interface ContentKeywordGq {
  id: number;
  keywordId: number;
  order: number;
  taskUrl: string;
  taskAction: ContentActionGq;
  taskId: number;
  serpResultId?: number;
  inH1: boolean;
  inTitle: boolean;
  inContent: boolean;
  keyword: string;
  keywordEnglish?: string;
  rank?: number;
  traffic?: number;
  volume: number;
  bestSerpUrl?: string;
  bestSerpRank?: number;
  bestDomainSerpUrl?: string;
  bestDomainSerpRank?: number;
  tags?: number[];
}

export const ContentKeywordGqProps = `
    id
    keywordId
    order
    taskId
    taskUrl
    taskAction
    serpResultId
    inH1
    inTitle
    inContent
    keyword
    keywordEnglish
    rank
    traffic
    volume
    bestSerpUrl
    bestSerpRank
    bestDomainSerpUrl
    bestDomainSerpRank
    tags
`;
